export function getObjectWithSelector(obj: any, selector: string): any {
  const keys = selector.split('.');
  let currentObject = obj;

  for (const key of keys) {
    if (!currentObject) {
      return undefined; // Return undefined if the path is invalid
    }
    currentObject = currentObject[key];
  }

  return currentObject;
}
